import React from "react";
import config from "../permission/config.json";
import { lazy } from "react";
import { Redirect, Route } from "react-router-dom";
import ListingForResignation from "../components/Listing/ListingForResignation";
import LWDResign from "../components/Listing/LWDResign";
import ResignationFlow from "../components/Resignation/ResignationFlow";
import Wfhlisting from "../components/leave/addleave/Wfhlisting";
import UserResignationList from "../components/Resignation/UserResignationList";
import { getResource } from "../util/getResourcePermission";
import { getRoles } from "../util/getRoles";
import { isHiddenForSubAdmin } from "../util/subAdminAccess";
import BillReimbursement from "../components/Billreimbursement/BillReimbursement";
import AddEditViewBillReimbursement from "../components/Billreimbursement/AddEditBillReimbusement";
import BillReimbursementApproval from "../components/Billreimbursement/AdminBillReimbursement";
import AdvanceRequest from "../components/ExpenseManagement/AdvanceRequest";
import ExpenseSubmission from "../components/ExpenseManagement/ExpenseSubmission";
import ExpenseApproval from "../components/ExpenseManagement/ExpenseApproval";
import ExpenseDashboard from "../components/ExpenseManagement/ExpenseDashboard";
import ExpenseReports from "../components/ExpenseManagement/ExpenseReports";
import ExpenseConfigAdmin from "../components/ExpenseManagement/ExpenseConfigAdmin";
import Karmasend from "../components/karma/Karmasend";
import Karmareceived from "../components/karma/Karmareceived";
import Karmareward from "../components/karma/Karmareward";
import KarmaWeightage from "../components/karma/KarmaWeightage";
import KarmaAdmin from "../components/karma/KarmaAdmin";
import KarmaApprovelAdmin from "../components/karma/KarmaApprovelAdmin";
import CategoryManager from "../components/karma/CategoryManager";
import KarmaSummery from "../components/karma/KarmaSummery";
import { message } from "antd";
import DocumentMaster from "../components/DocumentMaster/DocumentMaster";
import ReviewFormApprovals from "../components/ReviewForms/ReviewFormApprovals";
import ReviewFormTracker from "../components/ReviewForms/ReviewFormTracker";
import OnBoardingFormBuilder from "../components/FormBuilder/OnboardingFormBuilder";
import CandidateApprovalFormBuilder from "../components/FormBuilder/CandidateApprovalFormBuilder";
import OnboardingInitiationFormBuilder from "../components/FormBuilder/OnboardingInitiationFormBuilder";
import EmployeeMasterFormBuilder from "../components/FormBuilder/EmployeeMasterFormBuilder";
import RejoinEmployeeFormBuilder from "../components/FormBuilder/RejoinEmployeeFormBuilder";
import FormBuilderHub from "../components/FormBuilder/FormBuilderHub";
// import LeaveImportHistory from "../components/leave/addleave/LeaveImportHistory";

const AnalyticsStudio = lazy(() =>
  import("../components/Analytics/AnalyticsStudio")
);
const ClaimApprovalFromMail = lazy(() =>
  import("../components/Billreimbursement/ClaimApprovalFromMail")
);
const AnnouncementCategory = lazy(() =>
  import("../components/AnnouncementCategory/AnnouncementCategory")
);
// lazy ...
const CandidateApprovel = lazy(() =>
  import("../components/Onboarding/CandidateApprovel")
);
const CandidateApprovelList = lazy(() =>
  import("../components/Onboarding/CandidateApprovelList")
);
const EmailMaster = lazy(() => import("../components/EmailMaster/EmailMaster"));
const NotificationSettings = lazy(() => import("../components/NotificationSettings/NotificationSettings"));
const NewUserDashboard = lazy(() =>
  import("../components/NewDashboard/NewUserDashboard")
);

const ProjectOverView = lazy(() =>
  import("../components/ProjectOverview/ProjectOverView")
);

const CsvImportHistory = lazy(() =>
  import("../components/EmployeeMasterList/CsvImportHistory")
);

const OrganizationPolicy = lazy(() =>
  import("../components/OrganizationPolicy/OrganizationPolicy")
);
const Internmaster = lazy(() =>
  import("../components/Internmaster/Internmaster")
);

const UserDashboard = lazy(() =>
  import("../components/UserDashboard/UserDashboard")
);
const Userreports = lazy(() => import("../components/UserReports/UserReport"));

const UserAttendenceReport = lazy(() =>
  import("../components/UserReports/AttendenceReport/UserAttendenceRegister")
);
const UserInoutReport = lazy(() =>
  import("../components/UserReports/AttendenceReport/UserInOutRegister")
);
const ManageKpis = lazy(() => import("../components/ManageKPI/ManageKpi"));
const ViewKpi = lazy(() => import("../components/Kpi/ViewKpi"));
const AppraisalTemplates = lazy(() => import("../components/Performance/Templates/AppraisalTemplates"));
const PerformanceDashboard = lazy(() => import("../components/Performance/Dashboard/PerformanceDashboard"));
const PerformanceReports = lazy(() => import("../components/Performance/Reports/PerformanceReports"));
const DevelopmentPlan = lazy(() => import("../components/Performance/DevelopmentPlan/DevelopmentPlan"));
const Appraisal = lazy(() => import("../components/Performance/Appraisal"));
const TeamLeaveCalander = lazy(() =>
  import("../components/TeamLeaveCalander/TeamLeaveCalander")
);
const ManageTeamRegularization = lazy(() =>
  import("../components/ManageTeamRegularization/ManageTeamRegularization")
);
const TeamRank = lazy(() => import("../components/TeamRank/TeamRank"));

const EmployeeOverview = lazy(() =>
  import("../components/EmpInfoManagement/EmployeeOverview")
);
const AuditHistoryMonth = lazy(() =>
  import("../components/Audit/SuperAdminAuditHistory/AuditHistoryMonth")
);
const AuditHistoryOfEmp = lazy(() =>
  import("../components/Audit/AuditHistory/AuditHistoryOfEmp")
);
const CeoCompOffApprove = lazy(() =>
  import("../components/CeoCompoffApproval/CeoCompoffApproval")
);
const CEORegularization = lazy(() =>
  import("../components/CEORegurlarization/CEORegurlarization")
);
const SopMaster = lazy(() => import("../components/Audit/SopMaster/SopMaster"));
const Audits = lazy(() => import("../components/Audit/AuditHistory/Audits"));
const AuditMaster = lazy(() => import("../components/Audit/AuditMaster"));
const ViewReferCandidate = lazy(() =>
  import("../components/ReferCandidate/ViewReferCandidate")
);
const AppSettings = lazy(() => import("../components/AppSettings/AppSettings"));
const CandidateApproveReject = lazy(() =>
  import("../components/Onboarding/CandidateApproveReject")
);
const DocumentsApproveList = lazy(() =>
  import("../components/Onboarding/DocumentsApproveList")
);
const OnboardingInitiation = lazy(() =>
  import("../components/Onboarding/OnboardingInitiation")
);
const CandidateData = lazy(() =>
  import("../components/Onboarding/CandidateData")
);
const NewJoineesListAdmin = lazy(() =>
  import("../components/NewJoinees/NewJoineesListAdmin")
);
const NewJoineesForm = lazy(() =>
  import("../components/NewJoinees/NewJoineesForm")
);
const OrganizationView = lazy(() =>
  import("../components/OrganizationView/OrganizationView")
);
const NewAttendenceRegularizationList = lazy(() =>
  import(
    "../components/New-Attendence-regularization/NewAttendenceRegularizationList"
  )
);
const NewAttendenceRegularization = lazy(() =>
  import(
    "../components/New-Attendence-regularization/NewAttendenceRegularization"
  )
);

const AdminRoster = lazy(() => import("../components/AdminRoster/AdminRoster"));
const EditMyGoals = lazy(() => import("../components/Goals/EditMyGoals"));
const EditGoals = lazy(() => import("../components/Goals/EditGoals"));
const AdminOnduty = lazy(() => import("../components/AdminOnduty/AdminOnduty"));
const Viewuserkpi = lazy(() => import("../components/Userkpi/Viewuserkpi"));
const Userkpi = lazy(() => import("../components/Userkpi/Userkpi"));
const Viewadminkpi = lazy(() => import("../components/Adminkpi/Viewadminkpi"));
const LeaveApproval = lazy(() =>
  import("../components/leave/addleave/LeaveApproval")
);
const LeaveApplication = lazy(() =>
  import("../components/leave/addleave/LeaveApplication")
);
const CompOffLeave = lazy(() =>
  import("../components/leave/addleave/CompOffLeave")
);
const AddLeave = lazy(() => import("../components/leave/addleave/AddLeave"));
const AddWfhRequest = lazy(() =>
  import("../components/leave/addleave/AddWfhRequest")
);
const AdminWfhRequestApprove = lazy(() =>
  import("../components/leave/addleave/AdminWfhRequestApprove")
);

// Shift Swap / Double Shift / Shift Change (docs/swap-shift) — Phase 6.
// Only the self-service "my requests" list gets its own standalone route
// here — ShiftChangeApprove.js / AdminShiftChangeApprove.js are reached only
// as tabs inside LeaveApproval.js / AdminLeaveApprovel.js (see Pattern
// correction #2 in docs/swap-shift/06-frontend.md), matching the fact that
// no sibling approval screen (WFH, Comp-off, etc.) has its own route either.
const ShiftChangeListing = lazy(() =>
  import("../components/leave/addleave/ShiftChangeListing")
);
const FlexiLeaveApplication = lazy(() =>
  import("../components/leave/addleave/FlexiLeaveApplication")
);
const FlexiLeaveSettings = lazy(() =>
  import("../components/leave/addleave/FlexiLeaveSettings")
);
const OvertimeApplicationList = lazy(() =>
  import("../components/leave/addleave/OvertimeApplicationList")
);
const AdminLeaveApproval = lazy(() =>
  import("../components/leave/addleave/AdminLeaveApprovel")
);

const LeaveImportHistory = lazy(() =>
  import("../components/leave/addleave/LeaveImportHistory")
);

const FlexiLeaveImportHistory = lazy(() =>
  import("../components/leave/addleave/FlexiLeaveImportHistory")
);

const AdminDepartment = lazy(() =>
  import("../components/AdminDepartment/AdminDepartment")
);
const AdminFunctionRole = lazy(() =>
  import("../components/AdminFunctionRole/AdminFunctionRole")
);
const AdminBranch = lazy(() =>
  import("../components/AdminBranches/AdminBranches")
);
const AdminDesignation = lazy(() =>
  import("../components/AdminDepartment/AdminDesignation")
);
const AdminShift = lazy(() => import("../components/AdminShift/WorkHoursAndShifts"));
const AdminSubdepartment = lazy(() =>
  import("../components/AdminSubdepartment/AdminSubdepartment")
);
const AdminEmploymentType = lazy(() =>
  import("../components/AdminEmploymentType/AdminEmploymentType")
);
const BusinessUnit = lazy(() =>
  import("../components/BusinessUnit/BusinessUnit")
);

const Holidays = lazy(() => import("../components/Holidays/ViewHolidays"));

const Employeesrank = lazy(() =>
  import("../components/EmployeeRank/EmployeeRank")
);

const LeaveConfiguration = lazy(() =>
  import("../components/leave/addleave/LeaveConfiguration")
);

const ApprovalWorkflowSection = lazy(() =>
  import("../components/ApprovalWorkflow/ApprovalWorkflowSection")
);
const WorkflowBuilderPage = lazy(() =>
  import("../components/ApprovalWorkflow/WorkflowBuilderPage")
);
const ApprovalInbox = lazy(() => import("../components/Approvals/ApprovalInbox"));
const AttendanceSettings = lazy(() =>
  import("../components/AttendanceSettings/AttendanceSettings")
);
const NoticePeriodPolicies = lazy(() =>
  import("../components/NoticePeriodPolicies/NoticePeriodPolicies")
);

const EmployeeMasterList = lazy(() =>
  import("../components/EmployeeMasterList/EmployeeMasterList")
);
const EmployeeInout = lazy(() =>
  import("../components/EmployeeInout/EmployeeInout")
);

const AdminRegularization = lazy(() =>
  import("../components/AdminRegurlarization/AdminRegurlarization")
);

const AdminCompOffApprove = lazy(() =>
  import("../components/leave/addleave/AdminCompOffApprove")
);
const AdminLeaveCancellation = lazy(() =>
  import("../components/leave/addleave/AdminLeaveCancellation")
);

const AdminDashboard = lazy(() =>
  import("../components/AdminDashboard/AdminDashboard")
);
const NewDashboard = lazy(() =>
  import("../components/NewDashboard/NewDashboard")
);

const AdministrationData = lazy(() =>
  import("../components/SuperAdmin/Administrator")
);

const Exemployee = lazy(() =>
  import("../components/ExemployeeList/ExemployeeList")
);
const AddResignation = lazy(() =>
  import("../components/AddResignation/AddResignation")
);

const MyInOut = lazy(() => import("../components/MyInOut/MyInOut"));
const AttendenceRegularization = lazy(() =>
  import("../components/AttendenceRegularization/AttendenceRegularization")
);

const AddEmployeeMaster = lazy(() =>
  import("../components/AddEmployeeMaster/AddEmployeeMaster")
);

const AddEmployeeRank = lazy(() =>
  import("../components/AddEmployeeRank/AddEmployeeRank")
);

const Adminreports = lazy(() => import("../components/Reports/Reports"));

const ReferCandidate = lazy(() =>
  import("../components/ReferCandidate/ReferCandidate")
);
const EmpLeftreport = lazy(() =>
  import("../components/Reports/Employee Report/EmployeeLeftReport")
);
const EmpJoiningreport = lazy(() =>
  import("../components/Reports/Employee Report/EmployeeJoiningReport")
);
const FinanceReport = lazy(() =>
  import("../components/Reports/Finance Report/FinanceReport")
);
const EmpDataFormReport = lazy(() =>
  import("../components/Reports/Employee Report/EmployeeDataFormReport")
);
const EmpDocreport = lazy(() =>
  import("../components/Reports/Employee Report/EmployeeDocAttendence")
);

const AttendenceReport = lazy(() =>
  import("../components/Reports/Attendence Report/AttendenceRegister")
);
const Attendenceregularization = lazy(() =>
  import("../components/Reports/Attendence Report/Attendenceregularization")
);
const InoutReport = lazy(() =>
  import("../components/Reports/Attendence Report/InOutRegister")
);
const MonthlyReport = lazy(() =>
  import("../components/Reports/Attendence Report/MonthlyReport")
);
const PenaltyViolationReport = lazy(() =>
  import("../components/Reports/Attendence Report/PenaltyViolationReport")
);
const PenaltyRevoke = lazy(() => import("../components/PenaltyRevoke/PenaltyRevoke"));
const PenaltySummaryReport = lazy(() =>
  import("../components/Reports/Attendence Report/PenaltySummaryReport")
);
const PunchRejectionReport = lazy(() =>
  import("../components/Reports/Attendence Report/PunchRejectionReport")
);
const ShiftHistoryReport = lazy(() =>
  import("../components/Reports/Attendence Report/ShiftHistoryReport")
);

const Adminkpi = lazy(() => import("../components/Adminkpi/Adminkpi"));

const LeaveApplicationReport = lazy(() =>
  import("../components/Reports/Leave Report/LeaveApplication")
);
const LeaveApprovalReport = lazy(() =>
  import("../components/Reports/Leave Report/LeaveApproval")
);

const LeaveBalanceReport = lazy(() =>
  import("../components/Reports/Leave Report/LeaveBalance")
);

const LeaveHistoryReport = lazy(() =>
  import("../components/Reports/Leave Report/LeaveHistory")
);

const viewexemployee = lazy(() =>
  import("../components/viewexemployee/ViewExEmpTab")
);

const viewFeedbacks = lazy(() => import("../components/Feedback/Feedbacks"));

const AdminAddLeave = lazy(() =>
  import("../components/leave/addleave/AdminAddLeave")
);
const CompOffLeaveApplication = lazy(() =>
  import("../components/leave/addleave/CompOffLeaveApplication")
);

const achivementsListing = lazy(() =>
  import("../components/Achivements/achivementList")
);
const addAchivement = lazy(() =>
  import("../components/Achivements/AddAchivement")
);
const editAchivement = lazy(() =>
  import("../components/Achivements/EditAchivement")
);

const policiesListing = lazy(() =>
  import("../components/policies/policiesList")
);
const addPolicy = lazy(() => import("../components/policies/addPolicy"));
const teamTicketAdmin = lazy(() =>
  import("../components/TeamTicketAdmin/TicketList")
);
const TeamKpis = lazy(() => import("../components/TeamKpis/TeamKpis"));
const ticketListingTL = lazy(() =>
  import("../components/TeamTicket/TicketList")
);
const ViewTicketTLtickets = lazy(() =>
  import("../components/ViewTicketTL/ViewTicketTL")
);
const AdminAssetsMaster = lazy(() =>
  import("../components/Inventory/AdminAssetsMaster")
);
const Assets = lazy(() => import("../components/Inventory/Assets"));
const UserAssets = lazy(() => import("../components/UserInventory/Assets"));
const addAsset = lazy(() =>
  import("../components/InventoryTabpane/AddInventoryMaster")
);
const editAsset = lazy(() =>
  import("../components/Inventory/EditInventoryMaster")
);
const TestKpi = lazy(() => import("../components/TestKpi/TestKpi"));
const ViewTeamKpi = lazy(() => import("../components/TeamKpis/ViewTeamKpi"));
const ticketListing = lazy(() => import("../components/Ticket/TicketList"));
const AddTicket = lazy(() => import("../components/Ticket/AddTicket"));
const EditTicket = lazy(() => import("../components/EditTicket/EditTicket"));
const ViewTicket = lazy(() => import("../components/ViewTicket/ViewTicket"));
const AddGoals = lazy(() => import("../components/Goals/AddGoals"));
const GoalListing = lazy(() => import("../components/Goals/GoalListing"));
const GoalReports = lazy(() => import("../components/GoalReports/GoalReports"));
const TeamGoals = lazy(() => import("../components/Goals/TeamGoals"));
const CreatedGoals = lazy(() => import("../components/Goals/CreatedGoals"));
const ViewUserTicket = lazy(() =>
  import("../components/ViewTicket/viewTicketAsAdmin")
);
const editPolicy = lazy(() => import("../components/policies/editPolicy"));
const JobOpeningList = lazy(() =>
  import("../components/JobOpenings/JobOpeningList")
);
const AddJob = lazy(() => import("../components/JobOpenings/AddJob"));
const EditJob = lazy(() => import("../components/JobOpenings/EditJob"));
const ViewJob = lazy(() => import("../components/ViewJob/ViewJob"));
const assetTab = lazy(() => import("../components/InventoryTabpane/Asset"));
const EmpInfoManagement = lazy(() =>
  import("../components/EmpInfoManagement/EmpInfoManagement")
);
const NewAudit = lazy(() =>
  import("../components/Audit/AuditHistory/NewAudit")
);

const AuditPerformance = lazy(() =>
  import("../components/Audit/AuditPerformance")
);
const AuditHead = lazy(() => import("../components/Audit/AuditHead"));
const ViewAudits = lazy(() =>
  import("../components/Audit/SuperAdminAuditHistory/ViewAudits")
);
const SuperAdminAuditHistory = lazy(() =>
  import("../components/Audit/SuperAdminAuditHistory/SuperAdminAuditHistory")
);
const EditAudit = lazy(() =>
  import("../components/Audit/AuditHistory/EditAudit")
);
const ActionHub = lazy(() => import("../components/ActionHub/ActionHub"));
const ActionHubSettings = lazy(() => import("../components/ActionHubSettings/ActionHubSettings"));
const AddResignationForUSer = lazy(() =>
  import("../components/AdminSideUserResignation/AdminSideUserResignationFlow")
);
const QuaterUserRanking = lazy(() =>
  import("../components/IndividualquaterlyRank/QuaterUserRanking")
);
const PermissionModule = lazy(() =>
  import("../components/Permisson/PermissionList")
);
const PermissionAssignModule = lazy(() =>
  import("../components/Permisson/AssignPermission")
);
const AddTeamRank = lazy(() => import("../components/AddTeamRank/AddTeamRank"));
const WfhRequestApprove = lazy(() =>
  import("../components/leave/addleave/WfhRequestApprove")
);
const ticketListingTLMain = lazy(() =>
  import("../components/TeamTicketMaintl/TicketList")
);
const ViewTeamTicket = lazy(() =>
  import("../components/ViewTicket/ViewTeamTicket")
);
const CompOffApprove = lazy(() =>
  import("../components/leave/addleave/CompOffApprove")
);
const LeaveCancellation = lazy(() =>
  import("../components/leave/addleave/LeaveCancellation")
);
const EditLeaveCancellation = lazy(() =>
  import("../components/leave/addleave/EditLeaveCancellation")
);
const LeaveCancellationApproval = lazy(() =>
  import("../components/leave/addleave/LeaveCancellationApproval")
);
const DirectorCompOffApprove = lazy(() =>
  import("../components/DirectorCompoffApproval/DirectorCompoffApproval")
);
const Kpi = lazy(() => import("../components/Kpi/Kpi"));
const NewJoineesListTL = lazy(() =>
  import("../components/NewJoinees/NewJoineesListTL")
);
const AuditHistoryOfTL = lazy(() =>
  import("../components/Audit/AuditHistory/AuditHistoryOfTL")
);
const TeamInoutReport = lazy(() =>
  import("../components/TeamReports/AttendenceReport/UserInOutRegister")
);
const TeamAttendenceReport = lazy(() =>
  import("../components/TeamReports/AttendenceReport/UserAttendenceRegister")
);
const Teamreports = lazy(() => import("../components/TeamReports/UserReport"));
const GoalRecords = lazy(() => import("../components/Goals/GoalRecords"));
const EmpReferListing = lazy(() =>
  import("../components/Eldi/EmpReferListing")
);
const EmpDetails = lazy(() => import("../components/EmpDetails/EmpDetails"));

const CompnyDocMaster = lazy(() =>
  import("../components/CompnyDocMaster/CompnyDocMaster")
);
const SettingsModule = lazy(() =>
  import("../components/SettingsModule/SettingsModule")
);
const MeetingRoomBooking = lazy(() =>
  import("../components/MeetingRoomBooking/MeetingRoomBooking")
);
const MeetingRoomAdmin = lazy(() =>
  import("../components/MeetingRoomAdmin/MeetingRoomAdmin")
);
const ZohoPayrollIntegrationSettings = lazy(() =>
  import("../components/ZohoPayrollIntegration/ZohoPayrollIntegrationSettings")
);
const APIConsole = lazy(() => import("../components/APIConsole/APIConsole"));
const CompanyRegistration = lazy(() =>
  import("../components/CompanyRegistration/CompanyRegistration")
);

const companyEmployee = lazy(() =>
  import("../components/CompanyRegistration/CompanyEmployee")
);

const CompanyRegistrationForm = lazy(() =>
  import("../containers/CompanyRegistration/CompanyRegistrationForm")
);

const Questionnaire360 = lazy(() =>
  import("../components/360_degree_questionnaire/Questionnaire")
);
const AddNewQuestionnaire = lazy(() =>
  import("../components/360_degree_questionnaire/AddQuestionnaire")
);
const SurveyModule = lazy(() => import("../components/360_survey/Survey"));
const SurveyForm = lazy(() => import("../components/360_survey/SurveyForm"));

const ReviewModule360 = lazy(() =>
  import("../components/360_Degree_Reviews/ReviewsFile")
);
const AddNewReview = lazy(() =>
  import("../components/360_Degree_Reviews/AddNewReview")
);

const WeeklyMoodList = lazy(() =>
  import("../components/WeeklyMood/WeeklyMood")
);

const Reports = lazy(() =>
  import("../components/360_Degree_Reviews/ReviewReports")
);

const CompanyCronList = lazy(() =>
  import("../components/CompanyCronList/CompanyCronList")
);

const ActivityLogs = lazy(() =>
  import("../components/ActivityLogs/ActivityLogs")
);

const Skills = lazy(() =>
  import("../components/Skills/Skills")
);
const SkillsMatrix = lazy(() =>
  import("../components/SkillsMatrix/SkillsMatrix")
);
const SkillInventory = lazy(() =>
  import("../components/SkillInventory/SkillInventory")
);
const ViewSkillInventory = lazy(() =>
  import("../components/SkillInventory/ViewSkillInventory")
);

const RoleSkillRequirements = lazy(() =>
  import("../components/Skills/RoleSkillRequirements")
);

const SkillGapAnalysis = lazy(() =>
  import("../components/Skills/SkillGapAnalysis")
);

// Career Growth Path (Talent Management spec §5). Distinct from
// CareerPathTimeline below, which is the unrelated employment-history timeline.
const CareerPathMaster = lazy(() =>
  import("../components/CareerPath/CareerPathMaster")
);
const CareerPathBuilder = lazy(() =>
  import("../components/CareerPath/CareerPathBuilder")
);
const EmployeeCareerAssignment = lazy(() =>
  import("../components/CareerPath/EmployeeCareerAssignment")
);
const CareerRoleRequirements = lazy(() =>
  import("../components/CareerPath/CareerRoleRequirements")
);
const CourseSkillMapping = lazy(() =>
  import("../components/CareerPath/CourseSkillMapping")
);
const EmployeeCareerView = lazy(() =>
  import("../components/CareerPath/EmployeeCareerView")
);
const CareerReadinessDashboard = lazy(() =>
  import("../components/CareerPath/CareerReadinessDashboard")
);
const CompetencyMaster = lazy(() =>
  import("../components/Competency/CompetencyMaster")
);
const EmployeeCompetencies = lazy(() =>
  import("../components/Competency/EmployeeCompetencies")
);

const TalentDevelopment = lazy(() =>
  import("../components/TalentDevelopment")
);

const MiraGate = lazy(() => import("../components/ai/MiraGate"));
const CareerPathTimeline = lazy(() =>
  import("../components/CareerPathTimeline/CareerPathTimeline")
);

const RejoinEmployee = lazy(() =>
  import("../components/RejoinEmployee/RejoinEmployee")
);

const PerformanceCycles = lazy(() =>
  import("../components/Performance/PerformanceCycles")
);

const FRSManagement = lazy(() =>
  import("../components/FRSManagement/FRSManagement")
);

const PerformanceGoals = lazy(() =>
  import("../components/Performance/Goals")
);

const KPIMaster = lazy(() =>
  import("../components/Performance/KPIs/KPIMaster")
);

// LMS Module
const LmsCourseManagement = lazy(() =>
  import("../components/Lms/LmsCourseManagement")
);
const LmsAssessmentManagement = lazy(() =>
  import("../components/Lms/LmsAssessmentManagement")
);
const LmsEnrollments = lazy(() =>
  import("../components/Lms/LmsEnrollments")
);
const LmsMyLearning = lazy(() =>
  import("../components/Lms/LmsMyLearning")
);
const LmsCertificates = lazy(() =>
  import("../components/Lms/LmsCertificates")
);
const LmsLearningPath = lazy(() =>
  import("../components/Lms/LmsLearningPath")
);
const LmsAutoAssignment = lazy(() =>
  import("../components/Lms/LmsAutoAssignment")
);
const LmsTeamLearning = lazy(() =>
  import("../components/Lms/LmsTeamLearning")
);
const LmsReports = lazy(() =>
  import("../components/Lms/LmsReports")
);
const LmsManualGrading = lazy(() =>
  import("../components/Lms/LmsManualGrading")
);
const LmsDataRetention = lazy(() =>
  import("../components/Lms/LmsDataRetention")
);
const LmsCertificateTemplate = lazy(() =>
  import("../components/Lms/LmsCertificateTemplate")
);
const LmsCertificateTemplateEditor = lazy(() =>
  import("../components/Lms/LmsCertificateTemplateEditor")
);
const EngageAnnouncements = lazy(() =>
  import("../components/Engage/EngageAnnouncements")
);
const EngageCelebrations = lazy(() =>
  import("../components/Engage/EngageCelebrations")
);
const EngageAwards = lazy(() => import("../components/Engage/EngageAwards"));
const EngageBadges = lazy(() => import("../components/Engage/EngageBadges"));
const EngageWall = lazy(() => import("../components/Engage/EngageWall"));
const EngageModeration = lazy(() => import("../components/Engage/EngageModeration"));
const EngageSettings = lazy(() => import("../components/Engage/EngageSettings"));
const EngageOverview = lazy(() => import("../components/Engage/EngageOverview"));

// Legacy /announcement now lives at /engage/announcements. The route render
// loop calls React.createElement(item.component), so a tiny functional
// component performing the redirect keeps the old URL working.
const LegacyAnnouncementRedirect = () => {
  const companySlug = localStorage.getItem("companyDomain");
  return <Redirect to={`/${companySlug}/engage/announcements`} />;
};

// REMOVED: FaceRecognitionTest and FaceRecognitionInOut components (testing only)
// To restore, uncomment these lines:
// const FaceRecognitionTest = lazy(() =>
//   import("../components/FaceRecognitionTest/FaceRecognitionTest")
// );
// const FaceRecognitionInOut = lazy(() =>
//   import("../components/FaceRecognitionInOut/FaceRecognitionInOut")
// );

const NewRoutes = ({ match }) => {
  const userdata = JSON.parse(localStorage.getItem("user_data"));
  const companySlug = localStorage.getItem("companyDomain");
  const ALWAYS_ALLOWED_PATH_SUFFIXES = ["/my-profile", "/dashboard", "/team-leave-calender", "/admin/company-registartion", "/admin/settings", "/admin-email-master", "/admin-document-master", "/CompanyCronList", "/frs-management", "/announcement-category", "/engage/announcements", "/engage/celebrations", "/announcement", "/api-console", "/employee-overview", "/notification-settings", "/candidate-approval-master", "/onboarding-initiation-master", "/form-builder", "/book-meeting-room"];

  const hasReadAccess = (permissions = []) => {
    if (!Array.isArray(permissions) || permissions.length === 0) return false;
    return permissions.some((resourceName) => getResource(resourceName, ["read"]));
  };

  // Sub-Admin sees only what Permission Management grants: no settings/master
  // screens by URL, so it gets just the personal pages from the list above.
  const isSubAdmin = Boolean(getRoles(["Sub-Admin"]));
  // A few routes carry no permission of their own while the sidebar gates them
  // on a resource; Sub-Admin (permission-only access) is checked against that.
  const SUB_ADMIN_ROUTE_PERMISSION_FALLBACK = { "/mood-list": [config.RESOURCES.HOLIDAYS] };
  const subAdminRoutePermission = (item) => {
    if (item.permission?.length) return item.permission;
    const suffix = Object.keys(SUB_ADMIN_ROUTE_PERMISSION_FALLBACK).find((key) => String(item.path).endsWith(key));
    return suffix ? SUB_ADMIN_ROUTE_PERMISSION_FALLBACK[suffix] : [];
  };
  const SUB_ADMIN_ALLOWED_PATH_SUFFIXES = ["/my-profile", "/dashboard", "/team-leave-calender", "/engage/announcements", "/engage/celebrations", "/announcement", "/notification-settings", "/book-meeting-room"];

  const isAlwaysAllowedRoute = (path = "") => {
    const allowedSuffixes = isSubAdmin ? SUB_ADMIN_ALLOWED_PATH_SUFFIXES : ALWAYS_ALLOWED_PATH_SUFFIXES;
    return allowedSuffixes.some((suffix) => String(path).endsWith(suffix));
  };

  // Maps route paths to the same slugs used in the SuperAdmin plan HRMS_SIDEBAR_CATALOG.
  // If SuperAdmin enables a module in the plan, the matching route becomes accessible
  // regardless of RBAC - RBAC only controls action-level buttons inside the page.
  const pathToSidebarModuleSlug = (path = "") => {
    const p = String(path || "").toLowerCase();
    // Expense Management routes are plan-mapped. Checked BEFORE the generic
    // "/dashboard" slug below, which "/expense/dashboard" would otherwise match.
    if (p.includes("/expense/dashboard")) return "expense_dashboard";
    if (p.includes("/expense/advances")) return "expense_advance";
    if (p.includes("/expense/submit")) return "expense_submission";
    if (p.includes("/expense/approvals")) return "expense_approval";
    if (p.includes("/expense/reports")) return "expense_reports";
    if (p.includes("/expense/config")) return "expense_configuration";
    if (p.endsWith("/dashboard")) return "dashboard";
    if (p.endsWith("/my-in-out")) return "my_in_out";
    if (p.includes("/compoff-leave-application")) return "leave_application";
    if (p.endsWith("/leave-application")) return "leave_application";
    if (p.endsWith("/employee-attendence-regularization")) return "attendance_regularization";
    if (p.endsWith("/resignation")) return "resignation";
    if (p.endsWith("/tickets")) return "tickets";
    if (p.endsWith("/user-assets")) return "user_assets";
    if (p.endsWith("/user-reports")) return "user_reports";
    if (p.endsWith("/individual-rank")) return "individual_rank";
    if (p.endsWith("/bill-reimbursement")) return "bill_reimbursement";
    if (p.includes("/employee-master") || p.includes("/employee-overview")) return "employee_master";
    if (p.endsWith("/employee-in-out")) return "employee_in_out";
    if (p.endsWith("/resignation-employee-list")) return "resignation_employee_list";
    if (p.endsWith("/last-working-day-emps")) return "resignation";
    if (p.endsWith("/admin-reports")) return "admin_reports";
    if (p.endsWith("/employee-tickets")) return "employee_tickets";
    if (p.endsWith("/admin-leave-approval")) return "admin_leave_management";
    if (p.endsWith("/user-leave-approve")) return "user_leave_management";
    // Checked before /penalty-revoke - endsWith would match the user path too.
    if (p.endsWith("/user-penalty-revoke")) return "user_leave_management";
    if (p.endsWith("/penalty-revoke")) return "admin_leave_management";
    if (p.endsWith("/pending-task-list")) return "pending_task";
    if (p.endsWith("/admin-regularizatrion")) return "admin_regularization";
    if (p.endsWith("/manage-team-regularization")) return "manage_team_regularization";
    if (p.endsWith("/company-doc-master")) return "doc_master";
    if (p.endsWith("/onboarding-master")) return "onboarding_master";
    if (p.endsWith("/candidate-approval-master")) return "candidate_approval_master";
    if (p.endsWith("/onboarding-initiation-master")) return "onboarding_initiation_master";
    if (p.endsWith("/employee-master-form-builder")) return "employee_master_form_builder";
    if (p.endsWith("/rejoin-employee-form-builder")) return "rejoin_employee_form_builder";
    if (p.endsWith("/candidate-approval")) return "candidate_approval";
    if (p.endsWith("/candidate-list")) return "candidate_list";
    if (p.endsWith("/onboarding-initiation")) return "onboarding_initiation";
    if (p.endsWith("/doc-approve-list")) return "doc_approve_list";
    if (p.endsWith("/new-joinees-list")) return "new_joinees_list";
    if (p.endsWith("/mood-list")) return "mood_analytics";
    if (p.includes("/jobs/")) return "job_opening";
    if (p.endsWith("/inventory")) return "inventory";
    if (p.endsWith("/viewemployeedetails")) return "employee_details";
    if (p.endsWith("/organization-policy")) return "organization_policy";
    if (p.includes("/admin-bill-reimbursement")) return "admin_bill_reimbursement";
    if (p.includes("/engage/announcements")) return "announcement";
    if (p.includes("/engage/celebrations")) return "celebration";
    if (
      p.includes("/engage/wall") ||
      p.includes("/engage/awards") ||
      p.includes("/engage/badges") ||
      p.includes("/engage/moderation") ||
      p.includes("/engage/settings")
    ) return "wall";
    if (p.endsWith("/announcement") || p.endsWith("/announcement-category")) return "announcement";
    if (p.endsWith("/360-survey") || p.includes("/survey-form")) return "360_survey";
    if (p.endsWith("/360-questionnaire") || p.includes("/add/new-questionnaire")) return "questionnaire";
    if (p.endsWith("/360-reviews") || p.includes("/add/new-review") || p.includes("/360_reports")) return "360_reviews";
    if (p.endsWith("/activity-logs")) return "activity_logs";
    if (p.endsWith("/admin/zoho-payroll-integration")) return "zoho_payroll_integration";
    if (p.endsWith("/organization-view")) return "organization_tree";
    if (p.endsWith("/mira")) return "mira_ai";
    // Every Skills screen shares one RBAC resource and one plan slug.
    if (p.endsWith("/skills") || p.endsWith("/skills-matrix") || p.endsWith("/skill-inventory") || p.includes("/view-skill-inventory/") || p.endsWith("/role-skill-requirements") || p.endsWith("/skill-gap-analysis")) return "skill_master";
    // Career Growth Path screens share the CAREER_PATH resource and one plan slug.
    if (
      p.endsWith("/career-paths") ||
      p.includes("/career-path-builder/") ||
      p.endsWith("/employee-career-paths") ||
      p.endsWith("/career-role-requirements") ||
      p.endsWith("/course-skill-mapping") ||
      p.endsWith("/employee-career-view") ||
      p.endsWith("/career-readiness") ||
      p.endsWith("/competencies") ||
      p.endsWith("/employee-competencies")
    ) return "career_path";
    if (p.includes('/lms/')) return "learning";
    if (p.includes('/performance/')) return "performance";
    return "";
  };

  const hasPlanRouteAccess = (path = "") => {
    try {
      const raw = JSON.parse(localStorage.getItem("sidebarModuleAccess") || "[]");
      const sidebarModuleAccess = new Set(Array.isArray(raw) ? raw : []);
      // No plan configured - do not override RBAC
      if (sidebarModuleAccess.size === 0) return false;
      const slug = pathToSidebarModuleSlug(path);
      return slug ? sidebarModuleAccess.has(slug) : false;
    } catch {
      return false;
    }
  };

  // Overview is the Wall/Awards/Badges dashboard, so it belongs to the Wall &
  // Recognition cluster only — enabling Announcements or Celebrations alone
  // must not surface it. Despite the generic name, this is only used to gate
  // the /engage/overview route below.
  const hasAnyEngageModuleAccess = () => {
    try {
      const raw = JSON.parse(localStorage.getItem("sidebarModuleAccess") || "[]");
      const sidebarModuleAccess = new Set(Array.isArray(raw) ? raw : []);
      return sidebarModuleAccess.has("wall");
    } catch {
      return false;
    }
  };

  let routeArray = [
    // {
    //   path: "/register-company",
    //   component: CompanyRegistrationForm,
    //   permission: [],
    // },
    {
      path: `${companySlug}/analytics-studio`,
      component: AnalyticsStudio,
      permission: [config.RESOURCES.ANALYTICS],
      adminAllowed: true, // Admins always keep access (so a new resource never locks them out)
    },
    {
      path: `${companySlug}/my-in-out`,
      component: MyInOut,
      permission: [],
    },
    // {
    //   path: `${companySlug}/dashboard`,
    //   component:
    //     userdata?.role_id?.role_name == "Admin" || userdata?.role_id?.role_name == "HR"
    //       ? NewDashboard
    //       :
    //       NewUserDashboard,
    //   permission: [],
    // },

    {
      path: `${companySlug}/dashboard`,
      // Sub-Admin gets the company-wide Admin dashboard.
      component:
        userdata?.role_id?.role_name == "Admin" ||
          userdata?.role_id?.role_name == "HR" ||
          userdata?.role_id?.role_name == "Sub-Admin"
          ? NewDashboard
          : NewUserDashboard,
      permission: [],
    },

    //     {
    //   path: `${companySlug}/newdashboard`,
    //   component:
    //     userdata?.role_id?.role_name == "Admin" || userdata?.role_id?.role_name == "HR"
    //       ? NewDashboard
    //       : UserDashboard,
    //   permission: [],
    // },
    {
      path: `${companySlug}/admin/Administrator`,
      component: AdministrationData,
      permission: [],
    },

    {
      path: `${companySlug}/user-reports`,
      component: Userreports,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/user-reports/attendence-reports/attendence-register`,
      component: UserAttendenceReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/user-reports/attendence-reports/inout-register`,
      component: UserInoutReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/attendence-reports/attendence-register`,
      component: AttendenceReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/attendence-reports/inout-register`,
      component: InoutReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/organization-policy`,
      component: OrganizationPolicy,
      permission: [],
    },
    {
      path: `${companySlug}/organization-view`,
      component: OrganizationView,
      permission: [],
    },
    {
      path: `${companySlug}/resignation-employee-list`,
      component: ListingForResignation,
      permission: [config.RESOURCES.SEPARATION_MANAGEMENT],
    },
    {
      path: `${companySlug}/last-working-day-emps`,
      component: LWDResign,
      permission: [config.RESOURCES.LAST_WORKING_DAY_LIST],
    },
    {
      path: `${companySlug}/resignation`,
      component: ResignationFlow,
      permission: [config.RESOURCES.SEPARATION],
    },
    {
      path: `${companySlug}/refer-candidate`,
      component: ReferCandidate,
      permission: [config.RESOURCES.JOB_OPENING],
    },
    {
      path: `${companySlug}/view-refer-candidate/:id`,
      component: ViewReferCandidate,
      permission: [config.RESOURCES.JOB_OPENING],
    },
    {
      path: `${companySlug}/employee-overview/:id`,
      component: EmployeeOverview,
      permission: [],
    },
    {
      path: `${companySlug}/employee-overview`,
      component: EmployeeOverview,
      permission: [],
    },
    {
      path: `${companySlug}/employee-attendence-regularization`,
      component: AttendenceRegularization,
      permission: [config.RESOURCES.ATTENDANCE_REGULARIZATION],
    },
    {
      path: `${companySlug}/pending-task-list`,
      component: ActionHub,
      permission: [config.RESOURCES.PENDING_TASK],
    },
    {
      path: `${companySlug}/action-hub-settings`,
      component: ActionHubSettings,
      permission: [config.RESOURCES.SETTINGS],
    },
    {
      path: `${companySlug}/new-joinees-form`,
      component: NewJoineesForm,
      permission: [config.RESOURCES.NEW_JOINEES],
    },
    {
      path: `${companySlug}/new-joinees-list`,
      component: NewJoineesListAdmin,
      permission: [config.RESOURCES.NEW_JOINEES],
    },
    {
      path: `${companySlug}/onboarding-initiation`,
      component: OnboardingInitiation,
      permission: [config.RESOURCES.ON_BOARDING_INITIATION],
    },
    {
      path: `${companySlug}/doc-approve-list`,
      component: DocumentsApproveList,
      permission: [config.RESOURCES.ON_BOARDING_DOC_APPROVAL_LIST],
    },
    {
      path: `${companySlug}/doc-approve-reject/:id`,
      component: CandidateApproveReject,
      permission: [config.RESOURCES.ON_BOARDING_DOC_APPROVAL_LIST],
    },
    // {
    //   path: `${companySlug}/doc-approve-reject/:id`,
    //   component: CandidateData,
    //   permission: [config.RESOURCES.ON_BOARDING_DOC_APPROVAL_LIST],
    // },
    {
      path: `${companySlug}/adminonduty`,
      component: AdminOnduty,
      permission: [config.RESOURCES.ON_DUTY_REGULARIZATION],
    },
    {
      path: `${companySlug}/user-leave-approve`,
      component: LeaveApproval,
      permission: [config.RESOURCES.LEAVE_MANAGEMENT],
    },
    {
      path: `${companySlug}/inventory`,
      component: assetTab,
      permission: [config.RESOURCES.INVENTORY],
    },
    {
      path: `${companySlug}/create-goals`,
      component: AddGoals,
      permission: [config.RESOURCES.MY_GOAL],
    },
    {
      path: `${companySlug}/edit-goals/:id`,
      component: EditGoals,
      permission: [config.RESOURCES.MY_GOAL],
    },
    {
      path: `${companySlug}/edit-my-goals/:id`,
      component: EditMyGoals,
      permission: [config.RESOURCES.MY_GOAL],
    },
    {
      path: `${companySlug}/goals`,
      component: GoalListing,
      permission: [config.RESOURCES.MY_GOAL],
    },
    {
      path: `${companySlug}/team-goals`,
      component: TeamGoals,
      permission: [config.RESOURCES.TEAM_GOAL],
    },
    {
      path: `${companySlug}/employee-goals`,
      component: CreatedGoals,
      permission: [config.RESOURCES.EMPLOYEE_GOAL],
    },
    {
      path: `${companySlug}/my-goals`,
      component: CreatedGoals,
      permission: [config.RESOURCES.MY_GOAL],
    },
    {
      path: `${companySlug}/goal-reports`,
      component: GoalReports,
      permission: [config.RESOURCES.MY_GOAL],
    },
    {
      path: `${companySlug}/employee-master`,
      component: EmployeeMasterList,
      permission: [config.RESOURCES.EMPLOYEE_MASTER],
    },
    {
      path: `${companySlug}/my-profile`,
      component: EmpInfoManagement,
      permission: [],
    },
    {
      path: `${companySlug}/admin-compoff-approval`,
      component: AdminCompOffApprove,
      permission: [config.RESOURCES.C_OFF_MANAGEMENT],
    },
    {
      path: `${companySlug}/admin-leave-configuration`,
      component: LeaveConfiguration,
      permission: [config.RESOURCES.LEAVE_MASTER, config.RESOURCES.MANAGE_LEAVE_BALANCE],
    },
    {
      path: `${companySlug}/admin-attendance-settings`,
      component: AttendanceSettings,
      permission: [config.RESOURCES.ADMIN_REGULARIZATION],
    },
    {
      path: `${companySlug}/admin-notice-period-policies`,
      component: NoticePeriodPolicies,
      permission: [config.RESOURCES.SETTINGS],
    },
    {
      path: `${companySlug}/admin/approval-workflow`,
      component: ApprovalWorkflowSection,
      permission: [config.RESOURCES.APPROVAL_WORKFLOW_CONFIG],
    },
    {
      // The chain editor for one module. Its own page rather than a drawer -
      // levels, override rules, settings and a live preview do not fit one
      // narrow column, and the override rules have to be readable next to the
      // levels that produce them.
      path: `${companySlug}/admin/approval-workflow/:moduleKey`,
      component: WorkflowBuilderPage,
      permission: [config.RESOURCES.APPROVAL_WORKFLOW_CONFIG],
    },
    {
      path: `${companySlug}/my-approvals`,
      component: ApprovalInbox,
      permission: [config.RESOURCES.APPROVAL_INBOX],
    },
    {
      path: `${companySlug}/admin-assets-master`,
      component: AdminAssetsMaster,
      permission: [config.RESOURCES.MY_ASSETS],
    },
    {
      path: `${companySlug}/admin-assets`,
      component: Assets,
      permission: [config.RESOURCES.MY_ASSETS],
    },
    {
      path: `${companySlug}/admin-assets/add-asset`,
      component: addAsset,
      permission: [config.RESOURCES.MY_ASSETS],
    },
    {
      path: `${companySlug}/admin-assets/edit-asset/:id`,
      component: editAsset,
      permission: [config.RESOURCES.INVENTORY],
    },
    {
      path: `${companySlug}/user-assets`,
      component: UserAssets,
      permission: [config.RESOURCES.MY_ASSETS],
    },
    {
      path: `${companySlug}/designation-kpis`,
      component: Adminkpi,
      permission: [config.RESOURCES.KPI],
    },
    {
      path: `${companySlug}/user-kpis`,
      component: Userkpi,
      permission: [config.RESOURCES.KPI],
    },
    {
      path: `${companySlug}/view-designation-kpis/:id`,
      component: Viewadminkpi,
      permission: [config.RESOURCES.KPI],
    },
    {
      path: `${companySlug}/view-user-kpi/:id`,
      component: Viewuserkpi,
      permission: [config.RESOURCES.KPI],
    },
    {
      path: `${companySlug}/view-team-kpi/:id`,
      component: ViewTeamKpi,
      permission: [config.RESOURCES.KPI],
    },
    {
      path: `${companySlug}/admin-leave-cancellation`,
      component: AdminLeaveCancellation,
      permission: [config.RESOURCES.LEAVE_CANCELLATION_APPROVAL],
    },
    {
      path: `${companySlug}/admin-leave-approval`,
      component: AdminLeaveApproval,
      permission: [config.RESOURCES.ADMIN_LEAVE_MANAGEMENT],
    },
    {
      path: `${companySlug}/admin-leave-import-history`,
      component: LeaveImportHistory,
      permission: [config.RESOURCES.ADMIN_LEAVE_MANAGEMENT],
    },
    {
      path: `${companySlug}/admin-flexi-leave-import-history`,
      component: FlexiLeaveImportHistory,
      permission: [config.RESOURCES.FLEXI_LEAVE_APPROVAL],
    },
    {
      path: `${companySlug}/admin-department`,
      component: AdminDepartment,
      permission: [config.RESOURCES.DEPARTMENTS],
    },
    {
      path: `${companySlug}/skills`,
      component: Skills,
      permission: [config.RESOURCES.SKILL],
    },
    {
      path: `${companySlug}/skills-matrix`,
      component: SkillsMatrix,
      permission: [config.RESOURCES.SKILLS_MATRIX],
    },
    {
      path: `${companySlug}/skill-inventory`,
      component: SkillInventory,
      permission: [config.RESOURCES.SKILL_INVENTORY],
    },
    {
      path: `${companySlug}/view-skill-inventory/:id`,
      component: ViewSkillInventory,
      permission: [config.RESOURCES.SKILL_INVENTORY],
    },
    {
      path: `${companySlug}/role-skill-requirements`,
      component: RoleSkillRequirements,
      permission: [config.RESOURCES.SKILL],
    },
    {
      path: `${companySlug}/skill-gap-analysis`,
      component: SkillGapAnalysis,
      permission: [config.RESOURCES.SKILL],
    },
    {
      path: `${companySlug}/career-paths`,
      component: CareerPathMaster,
      permission: [config.RESOURCES.CAREER_PATH],
    },
    {
      path: `${companySlug}/career-path-builder/:careerPathId`,
      component: CareerPathBuilder,
      permission: [config.RESOURCES.CAREER_PATH],
    },
    {
      path: `${companySlug}/employee-career-paths`,
      component: EmployeeCareerAssignment,
      permission: [config.RESOURCES.EMPLOYEE_CAREER_PATH],
    },
    {
      path: `${companySlug}/career-role-requirements`,
      component: CareerRoleRequirements,
      permission: [config.RESOURCES.CAREER_PATH],
    },
    {
      path: `${companySlug}/course-skill-mapping`,
      component: CourseSkillMapping,
      permission: [config.RESOURCES.COURSE_SKILL_MAPPING],
    },
    {
      path: `${companySlug}/employee-career-view`,
      component: EmployeeCareerView,
      permission: [config.RESOURCES.EMPLOYEE_CAREER_VIEW],
    },
    {
      path: `${companySlug}/career-readiness`,
      component: CareerReadinessDashboard,
      permission: [config.RESOURCES.CAREER_READINESS],
    },
    {
      path: `${companySlug}/competencies`,
      component: CompetencyMaster,
      permission: [config.RESOURCES.COMPETENCY],
    },
    {
      path: `${companySlug}/employee-competencies`,
      component: EmployeeCompetencies,
      permission: [config.RESOURCES.EMPLOYEE_COMPETENCY],
    },
    {
      // Talent Development merges the Skills + Career Growth Path sidebar
      // groups into one tabbed page — visible if any one of the module's
      // resources is readable (hasReadAccess() below is a .some() over this
      // array, i.e. OR). Mirrors the per-tab gating inside TalentDevelopment/index.js.
      path: `${companySlug}/talent-development`,
      component: TalentDevelopment,
      permission: [
        config.RESOURCES.SKILL,
        config.RESOURCES.SKILLS_MATRIX,
        config.RESOURCES.SKILL_INVENTORY,
        config.RESOURCES.CAREER_PATH,
        config.RESOURCES.EMPLOYEE_CAREER_PATH,
        config.RESOURCES.EMPLOYEE_CAREER_VIEW,
        config.RESOURCES.CAREER_READINESS,
        config.RESOURCES.EMPLOYEE_COMPETENCY,
        config.RESOURCES.COURSE_SKILL_MAPPING,
      ],
    },
    {
      // Legacy URL — redirects to the Engage module page below.
      path: `${companySlug}/announcement`,
      component: LegacyAnnouncementRedirect,
      permission: [config.RESOURCES.ANNOUNCEMENT, config.RESOURCES.ENGAGE_PANEL],
    },
    {
      path: `${companySlug}/engage/announcements`,
      component: EngageAnnouncements,
      // Default-accessible — no RBAC resource, per design (see engage-wall-rbac-split memory).
      permission: [],
    },
    {
      path: `${companySlug}/engage/celebrations`,
      component: EngageCelebrations,
      permission: [],
    },
    {
      path: `${companySlug}/engage/awards`,
      component: EngageAwards,
      permission: [config.RESOURCES.ENGAGE_PANEL],
    },
    {
      path: `${companySlug}/engage/badges`,
      component: EngageBadges,
      permission: [config.RESOURCES.ENGAGE_PANEL],
    },
    {
      path: `${companySlug}/engage/wall`,
      component: EngageWall,
      permission: [config.RESOURCES.ENGAGE_WALL],
    },
    {
      path: `${companySlug}/engage/moderation`,
      component: EngageModeration,
      permission: [config.RESOURCES.ENGAGE_PANEL],
    },
    {
      path: `${companySlug}/engage/settings`,
      component: EngageSettings,
      permission: [config.RESOURCES.ENGAGE_PANEL],
    },
    {
      path: `${companySlug}/engage/overview`,
      component: EngageOverview,
      permission: [config.RESOURCES.ENGAGE_PANEL],
    },
    {
      path: `${companySlug}/announcement-category`,
      component: AnnouncementCategory,
      permission: [config.RESOURCES.ANNOUNCEMENT],
    },
    {
      path: `${companySlug}/admin-role`,
      component: AdminFunctionRole,
      permission: [config.RESOURCES.FUNCTION_ROLE],
    },
    {
      path: `${companySlug}/admin-branch`,
      component: AdminBranch,
      permission: [config.RESOURCES.BRANCH_OPTIONS],
    },
    {
      path: `${companySlug}/admin-designation`,
      component: AdminDesignation,
      permission: [config.RESOURCES.DESIGNATION],
    },
    {
      path: `${companySlug}/admin-employment-type`,
      component: AdminEmploymentType,
      permission: [config.RESOURCES.EMPLOYEMENT_TYPE],
    },
    {
      path: `${companySlug}/admin-shift`,
      component: AdminShift,
      permission: [config.RESOURCES.SHIFT],
    },
    {
      path: `${companySlug}/admin-subdepartment`,
      component: AdminSubdepartment,
      permission: [config.RESOURCES.SUBDEPARTMENT],
    },
    {
      path: `${companySlug}/admin-businessunit`,
      component: BusinessUnit,
      permission: [config.RESOURCES.BUSINESS_UNIT],
    },
    {
      path: `${companySlug}/holidays`,
      component: Holidays,
      permission: [config.RESOURCES.HOLIDAYS],
    },
    {
      path: `${companySlug}/admin-email-master`,
      component: EmailMaster,
      permission: [],
    },
    {
      path: `${companySlug}/notification-settings`,
      component: NotificationSettings,
      permission: [],
    },
    {
      path: `${companySlug}/employee-master/add-employee-master`,
      component: AddEmployeeMaster,
      permission: [config.RESOURCES.EMPLOYEE_MASTER],
    },
    {
      path: `${companySlug}/employee-master/update-employee-master/:id`,
      component: EmpInfoManagement,
      permission: [config.RESOURCES.EMPLOYEE_MASTER],
    },
    // {
    //   path: "employee-master/view-employee-master/:id`,
    //   component: EmployeeMasterView,
    //   permission: [config.RESOURCES.EMPLOYEE_MASTER],
    // },
    {
      path: `${companySlug}/ex-employee/view-resignation/:id`,
      component: viewexemployee,
      permission: [config.RESOURCES.EX_EMPLOYEE],
    },
    {
      path: `${companySlug}/employee-master/view-feedbacks/:id`,
      component: viewFeedbacks,
      permission: [config.RESOURCES.EX_EMPLOYEE],
    },
    {
      path: `${companySlug}/admin-reports`,
      component: Adminreports,
      // Finance Report can be granted on its own, so it must open the Reports page too.
      permission: [config.RESOURCES.EMPLOYEE_REPORT, config.RESOURCES.FINANCE_REPORT],
    },
    {
      path: `${companySlug}/manage-tickets`,
      component: ticketListingTL,
      permission: [config.RESOURCES.MANAGE_TICKET],
    },
    {
      path: `${companySlug}/manage-tickets/view-ticket/:id`,
      component: ViewTicketTLtickets,
      permission: [config.RESOURCES.MANAGE_TICKET],
    },
    {
      path: `${companySlug}/achivements`,
      component: achivementsListing,
      permission: [config.RESOURCES.ACHIEVEMENTS],
    },
    {
      path: `${companySlug}/permission-manager`,
      component: PermissionModule,
      permission: [config.RESOURCES.SETTINGS],
    },
    {
      path: `${companySlug}/permission-manager/:id`,
      component: PermissionAssignModule,
      permission: [config.RESOURCES.SETTINGS],
    },
    {
      path: `${companySlug}/policies`,
      component: policiesListing,
      permission: [config.RESOURCES.POLICIES],
    },
    {
      path: `${companySlug}/policies/add-policy`,
      component: addPolicy,
      permission: [config.RESOURCES.POLICIES],
    },
    {
      path: `${companySlug}/policies/edit-policy/:id`,
      component: editPolicy,
      permission: [config.RESOURCES.POLICIES],
    },
    {
      path: `${companySlug}/achivements/add-achivement`,
      component: addAchivement,
      permission: [config.RESOURCES.ACHIEVEMENTS],
    },
    {
      path: `${companySlug}/achivements/update-achivement/:id`,
      component: editAchivement,
      permission: [config.RESOURCES.ACHIEVEMENTS],
    },
    {
      path: `${companySlug}/employee-tickets`,
      component: teamTicketAdmin,
      permission: [config.RESOURCES.EMPLOYEE_TICKET],
    },
    {
      path: `${companySlug}/team-kpis`,
      component: TeamKpis,
      permission: [config.RESOURCES.KPI],
    },
    {
      path: `${companySlug}/Kpis`,
      component: TestKpi,
      permission: [config.RESOURCES.KPI],
    },
    {
      path: `${companySlug}/tickets`,
      component: ticketListing,
      permission: [config.RESOURCES.TICKET],
    },
    {
      path: `${companySlug}/tickets/add-ticket`,
      component: AddTicket,
      permission: [config.RESOURCES.TICKET],
    },
    {
      path: `${companySlug}/tickets/update-ticket/:id`,
      component: EditTicket,
      permission: [config.RESOURCES.TICKET],
    },
    {
      path: `${companySlug}/tickets/view-ticket/:id`,
      component: ViewTicket,
      permission: [config.RESOURCES.TICKET],
    },
    {
      path: `${companySlug}/employee-tickets/view-ticket/:id`,
      component: ViewUserTicket,
      permission: [config.RESOURCES.TICKET],
    },
    {
      path: `${companySlug}/employee-reports/emp-left-report`,
      component: EmpLeftreport,
      permission: [config.RESOURCES.EMPLOYEE_REPORT],
    },
    {
      path: `${companySlug}/employee-reports/emp-joining-report`,
      component: EmpJoiningreport,
      permission: [config.RESOURCES.EMPLOYEE_REPORT],
    },
    {
      path: `${companySlug}/employee-reports/emp-data-form`,
      component: EmpDataFormReport,
      permission: [config.RESOURCES.EMPLOYEE_REPORT],
    },
    {
      path: `${companySlug}/finance-reports/finance-report`,
      component: FinanceReport,
      permission: [config.RESOURCES.FINANCE_REPORT],
    },
    // {
    //   path: `${companySlug}/employee-reports/emp-doc-report`,
    //   component: EmpDocreport,
    //   permission: [config.RESOURCES.EMPLOYEE_REPORT],
    // },
    {
      path: `${companySlug}/admin-attendence-reports/attendence-register`,
      component: AttendenceReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/attendence-reports/attendence-regularization`,
      component: Attendenceregularization,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/employee-attendence-reports/inout-register`,
      component: InoutReport,
      permission: [config.RESOURCES.EMPLOYEE_REPORT],
    },
    {
      path: `${companySlug}/attendence-reports/monthly-register`,
      component: MonthlyReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/attendence-reports/penalty-violation`,
      component: PenaltyViolationReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/attendence-reports/penalty-summary`,
      component: PenaltySummaryReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      // Approvers reverse an applied penalty. Split the same way as leave approval -
      // admin-leave-approval / user-leave-approve - because the two paths map to two
      // different SuperAdmin plan modules. Admin/HR side.
      path: `${companySlug}/penalty-revoke`,
      component: PenaltyRevoke,
      permission: [config.RESOURCES.ADMIN_LEAVE_MANAGEMENT],
    },
    {
      // RM/ARM side of the same screen - the server scopes rows to their reportees.
      path: `${companySlug}/user-penalty-revoke`,
      component: PenaltyRevoke,
      permission: [config.RESOURCES.LEAVE_MANAGEMENT],
    },
    {
      path: `${companySlug}/attendence-reports/punch-rejection`,
      component: PunchRejectionReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/attendence-reports/shift-history`,
      component: ShiftHistoryReport,
      permission: [config.RESOURCES.ATTENDANCE_REPORT],
    },
    {
      path: `${companySlug}/leave-reports/leave-application`,
      component: LeaveApplicationReport,
      permission: [config.RESOURCES.LEAVE_REPORT],
    },
    {
      path: `${companySlug}/leave-reports/leave-approval`,
      component: LeaveApprovalReport,
      permission: [config.RESOURCES.LEAVE_REPORT],
    },
    {
      path: `${companySlug}/leave-reports/leave-balance`,
      component: LeaveBalanceReport,
      permission: [config.RESOURCES.LEAVE_REPORT],
    },
    {
      path: `${companySlug}/leave-reports/leave-history`,
      component: LeaveHistoryReport,
      permission: [config.RESOURCES.LEAVE_REPORT],
    },
    {
      path: `${companySlug}/ex-employee`,
      component: Exemployee,
      permission: [config.RESOURCES.EX_EMPLOYEE],
    },
    {
      path: `${companySlug}/ex-employee/add-resignation`,
      component: AddResignation,
      permission: [config.RESOURCES.EX_EMPLOYEE],
    },
    {
      path: `${companySlug}/employee-in-out`,
      component: EmployeeInout,
      permission: [config.RESOURCES.EMPLOYEE_IN_OUT],
    },
    {
      path: `${companySlug}/employee-ranking`,
      component: Employeesrank,
      permission: [config.RESOURCES.EMPLOYEE_RANKING],
    },
    {
      path: `${companySlug}/add-resignation-for-user`,
      component: AddResignationForUSer,
      permission: [config.RESOURCES.SEPARATION],
    },
    {
      path: `${companySlug}/add-employee-rank`,
      component: AddEmployeeRank,
      permission: [config.RESOURCES.EMPLOYEE_RANKING],
    },
    {
      path: `${companySlug}/admin-regularizatrion`,
      component: AdminRegularization,
      permission: [config.RESOURCES.ADMIN_REGULARIZATION],
    },

    {
      path: `${companySlug}/admin-work-from-home-approval`,
      component: AdminWfhRequestApprove,
      permission: [config.RESOURCES.WHF_MANAGEMENT],
    },
    {
      path: `${companySlug}/jobs/openings`,
      component: JobOpeningList,
      permission: [config.RESOURCES.JOB_OPENING],
    },
    {
      path: `${companySlug}/jobs/add`,
      component: AddJob,
      permission: [config.RESOURCES.JOB_OPENING],
    },
    {
      path: `${companySlug}/jobs/edit/:jobId`,
      component: EditJob,
      permission: [config.RESOURCES.JOB_OPENING],
    },
    {
      path: `${companySlug}/jobs/view/:id`,
      component: ViewJob,
      permission: [config.RESOURCES.JOB_OPENING],
    },
    {
      path: `${companySlug}/emp-info-management`,
      component: EmpInfoManagement,
      permission: [config.RESOURCES.EMPLOYEE_MASTER],
    },
    {
      path: `${companySlug}/auditmaster`,
      component: AuditMaster,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      path: `${companySlug}/sopmaster/:departmentId`,
      component: SopMaster,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      path: `${companySlug}/audits`,
      component: Audits,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      path: `${companySlug}/audit-history/:employeeId`,
      component: AuditHistoryOfEmp,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    // {
    //   path: `${companySlug}/team-audit-history`,
    //   component: AuditHistoryOfEmp,
    //   permission: [config.RESOURCES.AUDIT_MASTER],
    // },
    {
      path: `${companySlug}/new-audit/:employeeId`,
      component: NewAudit,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      path: `${companySlug}/edit-audit`,
      component: EditAudit,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      path: `${companySlug}/auditperformance`,
      component: AuditPerformance,
      permission: [config.RESOURCES.AUDITS_PERFORMANCE],
    },
    {
      path: `${companySlug}/auditHead`,
      component: AuditHead,
      permission: [config.RESOURCES.AUDIT_HEAD],
    },
    {
      path: `${companySlug}/viewaudits`,
      component: ViewAudits,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      path: `${companySlug}/audithistory/:employeeId`,
      component: SuperAdminAuditHistory,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      path: `${companySlug}/audit-month`,
      component: AuditHistoryMonth,
      permission: [config.RESOURCES.AUDIT_MASTER],
    },
    {
      path: `${companySlug}/audit-history-month`,
      component: AuditHistoryMonth,
      permission: [config.RESOURCES.AUDITS],
    },
    {
      path: `${companySlug}/individual-rank`,
      component: QuaterUserRanking,
      permission: [config.RESOURCES.RANKING],
    },
    {
      path: `${companySlug}/leave-application`,
      component: LeaveApplication,
      permission: [config.RESOURCES.LEAVE],
    },
    {
      path: `${companySlug}/leave-application/add-leave`,
      component: AddLeave,
      permission: [config.RESOURCES.LEAVE],
    },
    {
      path: `${companySlug}/admin-leave-approval/add-leave`,
      component: AdminAddLeave,
      permission: [config.RESOURCES.LEAVE],
    },
    {
      path: `${companySlug}/compoff-leave-application`,
      component: CompOffLeaveApplication,
    },
    {
      path: `${companySlug}/compoff-leave-application/add-compoff-leave`,
      component: CompOffLeave,
      permission: [config.RESOURCES.C_OFF_APPLICATIONS],
    },
    {
      path: `${companySlug}/add-work-from-home-application`,
      component: AddWfhRequest,
      permission: [config.RESOURCES.WHF_APPLICATIONS],
    },
    {
      path: `${companySlug}/resignation-userlist`,
      component: UserResignationList,
      permission: [config.RESOURCES.SEPARATION],
    },
    {
      path: `${companySlug}/work-from-home-application`,
      component: Wfhlisting,
      permission: [config.RESOURCES.LEAVE],
    },
    {
      path: `${companySlug}/shift-change-requests`,
      component: ShiftChangeListing,
      permission: [config.RESOURCES.SHIFT_SWAP_APPLICATION],
    },
    {
      path: `${companySlug}/flexi-leave-application`,
      component: FlexiLeaveApplication,
      permission: [config.RESOURCES.FLEXI_LEAVE_APPLICATIONS],
    },
    {
      path: `${companySlug}/flexi-leave-settings`,
      component: FlexiLeaveSettings,
      permission: [config.RESOURCES.FLEXI_LEAVE_SETTINGS],
    },
    {
      path: `${companySlug}/overtime-application`,
      component: OvertimeApplicationList,
      permission: [config.RESOURCES.OVERTIME_APPLICATIONS],
    },
    {
      path: `${companySlug}/newattendencelist`,
      component: NewAttendenceRegularizationList,
      permission: [config.RESOURCES.LEAVE],
    },
    {
      path: `${companySlug}/newattendence`,
      component: NewAttendenceRegularization,
      permission: [config.RESOURCES.LEAVE],
    },
    {
      path: `${companySlug}/app-setting`,
      component: AppSettings,
      permission: [],
    },
    {
      path: `${companySlug}/kpis-management`,
      component: ManageKpis,
      permission: [config.RESOURCES.KPI],
    },
    // {
    //   path: `${companySlug}/view-team-kpi/:id`,
    //   component: ViewTeamKpi,
    //   permission: [],
    // },
    {
      path: `${companySlug}/view-kpi/:id`,
      component: ViewKpi,
      permission: [config.RESOURCES.KPI],
    },
    {
      path: `${companySlug}/team-leave-calender`,
      component: TeamLeaveCalander,
      permission: [],
    },
    {
      path: `${companySlug}/manage-team-regularization`,
      component: ManageTeamRegularization,
      permission: [config.RESOURCES.TEAM_REGULARIZATION],
    },
    {
      path: `${companySlug}/team-ranking`,
      component: TeamRank,
      permission: [config.RESOURCES.RANKING],
    },
    {
      path: `${companySlug}/add-team-rank`,
      component: AddTeamRank,
      permission: [config.RESOURCES.EMPLOYEE_MASTER],
    },
    {
      path: `${companySlug}/add-team-employee-rank`,
      component: AddTeamRank,
      permission: [config.RESOURCES.EMPLOYEE_RANKING],
    },
    {
      path: `${companySlug}/work-from-home-approval`,
      component: WfhRequestApprove,
      permission: [config.RESOURCES.WHF_MANAGEMENT],
    },
    {
      path: `${companySlug}/leave-reports`,
      component: LeaveApplicationReport,
      permission: [config.RESOURCES.LEAVE_REPORT],
    },
    {
      path: `${companySlug}/team-tickets`,
      component: ticketListingTLMain,
      permission: [config.RESOURCES.TICKET],
    },
    {
      path: `${companySlug}/team-tickets/view-ticket/:id`,
      component: ViewTeamTicket,
      permission: [config.RESOURCES.TICKET],
    },
    {
      path: `${companySlug}/compoff-approve`,
      component: CompOffApprove,
      permission: [config.RESOURCES.C_OFF_MANAGEMENT],
    },
    {
      path: `${companySlug}/ceo-compoff-approval`,
      component: CeoCompOffApprove,
      permission: [config.RESOURCES.C_OFF_MANAGEMENT],
    },
    {
      path: `${companySlug}/ceo-regularizatrion`,
      component: CEORegularization,
      permission: [config.RESOURCES.LEAVE],
    },
    {
      path: `${companySlug}/leave-cancellation`,
      component: LeaveCancellation,
      permission: [config.RESOURCES.LEAVE_CANCELLATION_APPLICATION],
    },
    {
      path: `${companySlug}/leave-cancellation/:id`,
      component: EditLeaveCancellation,
      permission: [config.RESOURCES.LEAVE_CANCELLATION_APPLICATION],
    },
    {
      path: `${companySlug}/leave-cancellation-approve`,
      component: LeaveCancellationApproval,
      permission: [config.RESOURCES.LEAVE_CANCELLATION_APPROVAL],
    },
    {
      path: `${companySlug}/director-compoff-approval`,
      component: DirectorCompOffApprove,
      permission: [config.RESOURCES.C_OFF_MANAGEMENT],
    },

    //ceo
    {
      path: `${companySlug}/user-eldi-refer`,
      component: EmpReferListing,
      permission: [config.RESOURCES.JOB_OPENING],
    },
    {
      path: `${companySlug}/goal-records/:goal_id`,
      component: GoalRecords,
      permission: [config.RESOURCES.MY_GOAL],
    },
    {
      path: `${companySlug}/team-reports`,
      component: Teamreports,
      permission: [config.RESOURCES.EMPLOYEE_REPORT],
    },
    {
      path: `${companySlug}/team-reports/attendence-reports/attendence-register`,
      component: TeamAttendenceReport,
      permission: [config.RESOURCES.EMPLOYEE_REPORT],
    },
    {
      path: `${companySlug}/team-reports/attendence-reports/inout-register`,
      component: TeamInoutReport,
      permission: [config.RESOURCES.EMPLOYEE_REPORT],
    },
    {
      path: `${companySlug}/audit-history`,
      component: AuditHistoryOfTL,
      permission: [config.RESOURCES.AUDITS],
    },
    {
      path: `${companySlug}/my-audit-history`,
      component: AuditHistoryOfTL,
      permission: [config.RESOURCES.AUDITS],
    },
    {
      path: `${companySlug}/new-joinees`,
      component: NewJoineesListTL,
      permission: [config.RESOURCES.NEW_JOINEES],
    },
    {
      path: `${companySlug}/user-kpi`,
      component: Kpi,
      permission: [],
    },
    {
      path: `${companySlug}/viewEmployeeDetails`,
      component: EmpDetails,
      permission: [config.RESOURCES.EMPLOYEE_DETAILS],
    },
    {
      path: `${companySlug}/intern-master`,
      component: Internmaster,
      permission: [config.RESOURCES.EMPLOYEE_MASTER],
    },
    {
      path: `${companySlug}/bill-reimbursement`,
      component: BillReimbursement,
      permission: [config.RESOURCES.BILLREIMBURSEMENT],
    },
    {
      path: `${companySlug}/bill-reimbursement/add`,
      component: AddEditViewBillReimbursement,
      permission: [config.RESOURCES.BILLREIMBURSEMENT],
    },
    {
      path: `${companySlug}/bill-reimbursement/edit/:id`,
      component: AddEditViewBillReimbursement,
      permission: [config.RESOURCES.BILLREIMBURSEMENT],
    },
    {
      path: `${companySlug}/bill-reimbursement/view/:id`,
      component: AddEditViewBillReimbursement,
      permission: [config.RESOURCES.BILLREIMBURSEMENT],
    },
    {
      path: `${companySlug}/admin-bill-reimbursement/submit`,
      component: BillReimbursementApproval,
      permission: [config.RESOURCES.BILLREIMBURSEMENT_APPROVAL],
    },
    {
      path: `${companySlug}/user-claim-approve`,
      component: ClaimApprovalFromMail,
      permission: [],
    },
    {
      path: `${companySlug}/user-claim-approve`,
      component: ClaimApprovalFromMail,
      permission: [],
    },
    {
      path: `${companySlug}/user-claim-approve`,
      component: ClaimApprovalFromMail,
      permission: [],
    },

    // Enhanced Expense Management routes:
    {
      path: `${companySlug}/expense/advances`,
      component: AdvanceRequest,
      permission: [config.RESOURCES.EXPENSE_ADVANCE],
    },
    {
      path: `${companySlug}/expense/submit`,
      component: ExpenseSubmission,
      permission: [config.RESOURCES.EXPENSE_SUBMISSION],
    },
    {
      path: `${companySlug}/expense/approvals`,
      component: ExpenseApproval,
      permission: [config.RESOURCES.EXPENSE_APPROVAL],
    },
    {
      path: `${companySlug}/expense/dashboard`,
      component: ExpenseDashboard,
      permission: [config.RESOURCES.EXPENSE_DASHBOARD],
    },
    {
      path: `${companySlug}/expense/reports`,
      component: ExpenseReports,
      permission: [config.RESOURCES.EXPENSE_REPORTS],
    },
    {
      path: `${companySlug}/expense/config`,
      component: ExpenseConfigAdmin,
      permission: [config.RESOURCES.EXPENSE_CONFIG],
    },

    // Waffle routes:
    {
      path: `${companySlug}/Waffle`,
      component: Karmasend,
      permission: [config.RESOURCES.WAFFLE],
    },
    {
      path: `${companySlug}/Waffle-reward`,
      component: Karmareward,
      permission: [config.RESOURCES.WAFFLE_REWARD],
    },
    {
      path: `${companySlug}/Waffle-weightage`,
      component: KarmaWeightage,
      permission: [config.RESOURCES.WAFFLE_WEIGHTAGE],
    },
    {
      path: `${companySlug}/Waffle-reward-approvel`,
      component: KarmaApprovelAdmin,
      permission: [config.RESOURCES.WAFFLE_REWARD],
    },
    {
      path: `${companySlug}/Waffle-category`,
      component: CategoryManager,
      permission: [config.RESOURCES.WAFFLE],
    },
    {
      path: `${companySlug}/Waffle-summary`,
      component: KarmaSummery,
      permission: [config.RESOURCES.WAFFLE],
    },

    //CandidateApprovel
    {
      path: `${companySlug}/candidate-approval`,
      component: CandidateApprovel,
      permission: [config.RESOURCES.CANDIDATE_APPROVAL],
    },
    {
      path: `${companySlug}/candidate-list`,
      component: CandidateApprovelList,
      permission: [config.RESOURCES.CANDIDATE_APPROVAL],
    },
    {
      path: `${companySlug}/company-doc-master`,
      component: CompnyDocMaster,
      permission: [config.RESOURCES.ON_BOARDING_INITIATION],
    },
    {
      path: `${companySlug}/onboarding-master`,
      component: OnBoardingFormBuilder,
      permission: [],
    },
    {
      path: `${companySlug}/candidate-approval-master`,
      component: CandidateApprovalFormBuilder,
      permission: [],
    },
    {
      path: `${companySlug}/onboarding-initiation-master`,
      component: OnboardingInitiationFormBuilder,
      permission: [],
    },
    {
      path: `${companySlug}/employee-master-form-builder`,
      component: EmployeeMasterFormBuilder,
      permission: [],
    },
    {
      path: `${companySlug}/rejoin-employee-form-builder`,
      component: RejoinEmployeeFormBuilder,
      permission: [],
    },
    {
      path: `${companySlug}/form-builder`,
      component: FormBuilderHub,
      permission: [],
    },
    {
      path: `${companySlug}/admin/settings`,
      component: SettingsModule,
      permission: [],
    },
    {
      path: `${companySlug}/book-meeting-room`,
      component: MeetingRoomBooking,
      permission: [],
    },
    {
      path: `${companySlug}/meeting-rooms`,
      component: MeetingRoomAdmin,
      permission: [config.RESOURCES.MEETING_ROOM],
    },
    {
      path: `${companySlug}/admin/zoho-payroll-integration`,
      component: ZohoPayrollIntegrationSettings,
      permission: [],
    },
    {
      path: `${companySlug}/api-console`,
      component: APIConsole,
      permission: [],
    },
    {
      path: `${companySlug}/admin/company-registartion`,
      component: CompanyRegistration,
      permission: [],
    },
    {
      path: `${companySlug}/admin/company-employee`,
      component: companyEmployee,
      permission: [],
    },
    {
      path: `${companySlug}/admin-roster`,
      component: AdminRoster,
      permission: [config.RESOURCES.SHIFT],
    },
    {
      path: `${companySlug}/360-questionnaire`,
      component: Questionnaire360,
      permission: [config.RESOURCES["360QUE"]],
    },

    {
      path: `${companySlug}/add/new-review/:id?`,
      component: AddNewReview,
      permission: [config.RESOURCES["360REVW"]],
    },
    {
      path: `${companySlug}/360-reviews`,
      component: ReviewModule360,
      permission: [config.RESOURCES["360REVW"]],
    },
    {
      path: `${companySlug}/add/new-questionnaire/:id?`,
      component: AddNewQuestionnaire,
      permission: [config.RESOURCES["360QUE"]],
    },
    {
      path: `${companySlug}/360-survey`,
      component: SurveyModule,
      permission: [config.RESOURCES["SURVEY"]],
    },
    {
      path: `${companySlug}/survey-form/:id?`,
      component: SurveyForm,
      permission: [config.RESOURCES["SURVEY"]],
    },
    {
      path: `${companySlug}/360_reports/:id?`,
      component: Reports,
      permission: [config.RESOURCES["360REVW"]],
    },
    {
      path: `${companySlug}/mood-list`,
      component: WeeklyMoodList,
      permission: [],
    },
    {
      path: `${companySlug}/CompanyCronList`,
      component: CompanyCronList,
      permission: [],
    },
    {
      path: `${companySlug}/employee-master/csv-import-history`,
      component: CsvImportHistory,
      permission: [],
    },
    {
      path: `${companySlug}/project-overview`,
      component: ProjectOverView,
      permission: [],
    },
    {
      path: `${companySlug}/activity-logs`,
      component: ActivityLogs,
      permission: [],
    },
    {
      path: `${companySlug}/mira`,
      component: MiraGate,
      permission: [],
    },

    {
      path: "employee-history/:id",
      component: CareerPathTimeline,
      permission: [config.RESOURCES.EMPLOYEE_MASTER],
    },
    {
      path: `${companySlug}/ex-employee/rejoin-employee/:id`,
      component: RejoinEmployee,
      permission: [config.RESOURCES.EX_EMPLOYEE],
    },
    {
      path: `${companySlug}/frs-management`,
      component: FRSManagement,
      permission: [],
    },
    {
      path: `${companySlug}/admin-document-master`,
      component: DocumentMaster,
      permission: [],
    },
    {
      // `permission: []` means DENIED here, not "public" - hasReadAccess()
      // returns false for an empty list. Copying that from the always-allowed
      // admin-document-master route is what left this page blank.
      path: `${companySlug}/review-form-approvals`,
      component: ReviewFormApprovals,
      permission: [config.RESOURCES.REVIEW_FORMS],
    },
    {
      path: `${companySlug}/review-forms`,
      component: ReviewFormTracker,
      permission: [config.RESOURCES.REVIEW_FORMS],
    },
    {
      path: `${companySlug}/performance/dashboard`,
      component: PerformanceDashboard,
      permission: [config.RESOURCES.PERFORMANCE_DASHBOARD],
    },
    {
      path: `${companySlug}/performance/cycles`,
      component: PerformanceCycles,
      permission: [config.RESOURCES.PERFORMANCE_CYCLES],
    },
    {
      path: `${companySlug}/performance/development-plan`,
      component: DevelopmentPlan,
      permission: [config.RESOURCES.PERFORMANCE_DEVELOPMENT_PLAN],
    },
    {
      path: `${companySlug}/performance/reports`,
      component: PerformanceReports,
      permission: [config.RESOURCES.PERFORMANCE_REPORTS],
    },
    {
      path: `${companySlug}/performance/goals`,
      component: PerformanceGoals,
      permission: [config.RESOURCES.PERFORMANCE_GOALS],
    },
    {
      path: `${companySlug}/performance/kpi-kra`,
      component: KPIMaster,
      permission: [config.RESOURCES.PERFORMANCE_KPI_KRA],
    },
    {
      path: `${companySlug}/performance/templates`,
      component: AppraisalTemplates,
      permission: [config.RESOURCES.PERFORMANCE_TEMPLATES],
    },
    {
      path: `${companySlug}/performance/appraisal`,
      component: Appraisal,
      permission: [config.RESOURCES.PERFORMANCE_APPRAISAL],
    },

    // REMOVED: Face recognition test routes (testing only)
    // To restore, uncomment these routes:
    // {
    //   path: `${companySlug}/face-recognition-test`,
    //   component: FaceRecognitionTest,
    //   permission: [],
    // },
    // {
    //   path: `${companySlug}/face-recognition-inout`,
    //   component: FaceRecognitionInOut,
    //   permission: [],
    // },

    // ─── LMS Module Routes ────────────────────────────────────────────
    {
      path: `${companySlug}/lms/courses`,
      component: LmsCourseManagement,
      permission: [config.RESOURCES.LMS_COURSE_MANAGEMENT],
    },
    {
      path: `${companySlug}/lms/assessments`,
      component: LmsAssessmentManagement,
      permission: [config.RESOURCES.LMS_ASSESSMENT_MANAGEMENT],
    },
    {
      path: `${companySlug}/lms/enrollments`,
      component: LmsEnrollments,
      permission: [config.RESOURCES.LMS_ENROLLMENT],
    },
    {
      path: `${companySlug}/lms/my-learning`,
      component: LmsMyLearning,
      permission: [config.RESOURCES.LMS_MY_LEARNING],
    },
    {
      path: `${companySlug}/lms/certificates`,
      component: LmsCertificates,
      permission: [config.RESOURCES.LMS_CERTIFICATES],
    },
    {
      path: `${companySlug}/lms/learning-paths`,
      component: LmsLearningPath,
      permission: [config.RESOURCES.LMS_LEARNING_PATH],
    },
    {
      path: `${companySlug}/lms/auto-assignment`,
      component: LmsAutoAssignment,
      permission: [config.RESOURCES.LMS_AUTO_ASSIGNMENT],
    },
    {
      path: `${companySlug}/lms/team-learning`,
      component: LmsTeamLearning,
      permission: [config.RESOURCES.LMS_TEAM_LEARNING],
    },
    {
      path: `${companySlug}/lms/reports`,
      component: LmsReports,
      permission: [config.RESOURCES.LMS_REPORTS],
    },
    {
      path: `${companySlug}/lms/grading`,
      component: LmsManualGrading,
      permission: [config.RESOURCES.LMS_ASSESSMENT_MANAGEMENT],
    },
    {
      path: `${companySlug}/lms/settings/data-retention`,
      component: LmsDataRetention,
      permission: [config.RESOURCES.LMS_REPORTS],
    },
    {
      path: `${companySlug}/lms/settings/certificate-template`,
      component: LmsCertificateTemplateEditor,
      permission: [config.RESOURCES.LMS_COURSE_MANAGEMENT],
    },
  ];

  return (
    <>
      {routeArray.map((item, index) => {
        const allowedUserIds = item.allowedUserIds || [];
        // Determine if a plan has been configured for this company.
        // When a plan is configured, plan-module slugs are stored in sidebarModuleAccess.
        // Routes that map to a plan-controlled sidebar module slug must be gated by the
        // plan, not RBAC - otherwise every Admin bypasses the plan gate via role permissions.
        // Non-plan-mapped routes (e.g. permission-manager, my-profile) always use RBAC.
        const routeSlug = pathToSidebarModuleSlug(item.path);
                // Plan-exempt slugs (Skills module) resolve to "" so the guard falls
        // through to the RBAC branch below.
        const planGatedSlug = routeSlug;

        const isEngageOverviewRoute = item.path.endsWith("/engage/overview");
        // Engage Wall + its admin-panel siblings (Awards/Badges/Moderation/
        // Settings, which all share the "wall" plan slug) are the one family
        // of plan-mapped routes that must also respect per-role RBAC — see
        // the engage-wall-rbac-split memory. A Reporting Manager with 0/0/0/0
        // on their Engage resource must not reach /engage/wall by direct URL
        // just because the company's plan has the Wall module enabled.
        // Every other plan-mapped module intentionally keeps the original
        // "plan grant only" behavior (see comment below) — this is a
        // narrowly-scoped exception, not a global policy change.
        const isEngageWallFamilyRoute = planGatedSlug === "wall";
        const sidebarRaw = (() => { try { return JSON.parse(localStorage.getItem("sidebarModuleAccess") || "[]"); } catch { return []; } })();
        const hasPlanConfig = Array.isArray(sidebarRaw) && sidebarRaw.length > 0;
        // Settings/master screens are never opened by Sub-Admin, whatever it is granted.
        const hasPermission = !isHiddenForSubAdmin(item.path) && (
          isAlwaysAllowedRoute(item.path) ||
          allowedUserIds.includes(userdata?._id) ||
          (item.adminAllowed && getRoles(["Admin"])) || // Admins never lose a newly-added resource
          ((routeSlug || isEngageOverviewRoute) && hasPlanConfig
            ? (isEngageOverviewRoute
                ? hasAnyEngageModuleAccess() && hasReadAccess(item.permission) // overview: plan AND per-role RBAC
                : isEngageWallFamilyRoute
                  ? hasPlanRouteAccess(item.path) && hasReadAccess(item.permission) // Wall/admin-panel: plan AND per-role RBAC
                  : isSubAdmin
                    ? hasPlanRouteAccess(item.path) && hasReadAccess(subAdminRoutePermission(item)) // Sub-Admin: plan AND per-role RBAC
                    : hasPlanRouteAccess(item.path)) // every other plan-mapped route: plan grant only (unchanged, documented intent)
            : hasReadAccess(isSubAdmin ? subAdminRoutePermission(item) : item.permission))); // no plan or unmapped route: RBAC

        return (
          <Route
            exact
            key={index}
            path={`${match.url}${item.path}`}
            render={(routeProps) => {
              if (!hasPermission) {
                message.error("You don't have permission to access this page");
                return <Redirect to={`/${companySlug}/my-profile`} />;
              }
              return React.createElement(item.component, { ...routeProps });
            }}
          />
        );
      })}
    </>
  );
};

export default NewRoutes;
